import React, { useContext } from 'react';
import ColorsContext from './ColorsContext';
import ISLTable from './ISLTable';

export default function ResvTable(props) {
  const { regionData, monyr } = props;
  const { levelColors } = useContext(ColorsContext);
  
  let droughtRegions = [
    "Western",
    "Connecticut River",
    "Central",
    "Northeast",
    "Southeast",
    "Cape Cod"
  ];

  if (regionData['Islands']) {
    droughtRegions.push("Islands");
  };

  return (
    <>
      <table className="pcpnTable-container">
        <caption>
          {monyr} {monyr.search(",") < 0 ? "Monthly" : "30-Day"} Lakes and Impoundments Summary<br />
          <ISLTable />
        </caption>
        <thead>
          <tr>
            <th scope="col">Region</th>
            <th scope="col">{"Number of sites reporting"}</th>
            <th scope="col" abbr="Percentile">{"Median of individual percentiles or percent full"}</th>
          </tr>
        </thead>
        <tbody>
          {droughtRegions.map((rd, i) => (
              <tr key={i}>
                <th scope="row">{rd.replace("Connecticut River","CTRV")}</th>
                <td>{regionData.hasOwnProperty(rd) ? regionData[rd].count : 0}</td>
                <td 
                  style={{
                    backgroundColor: regionData.hasOwnProperty(rd) ? levelColors[regionData[rd].level] : "lightgray", 
                    color: regionData.hasOwnProperty(rd) ? (regionData[rd].level !== 4 ? "black" : "white") : "black"
                  }}
                >
                  {regionData.hasOwnProperty(rd) ? regionData[rd].percentile : "NA"}
                </td>
              </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}